import { render, staticRenderFns } from "./BremenHowTo.vue?vue&type=template&id=3eba97e3&"
import script from "./BremenHowTo.vue?vue&type=script&lang=js&"
export * from "./BremenHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports